export default __webpack_public_path__ + "static/media/contact_usBg.90aff775.jpg";